<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <validation-observer
      ref="workflowForm"
      #default="{ handleSubmit }"
    >
      <b-form
        ref="formGroupAssign"
        @submit.prevent="handleSubmit(saveGroupAssign)"
      >
        <!-- Workflow -->
        <validation-provider
          #default="{ errors }"
          name="Quy trình làm việc"
          rules="required"
        >
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Quy trình làm việc <span class="text-danger">*</span></label>
            </template>
            <v-select
              v-model="assignWorkflowData.workflow_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="workflowOptions"
              :reduce="(val) => val.id"
              :state="errors.length > 0 ? false : null"
              placeholder="--Chọn--"
              label="name"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <!-- Collection -->
        <validation-provider
          #default="{ errors }"
          name="Nhóm chuyên mục"
          rules="required"
        >
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Nhóm chuyên mục <span class="text-danger">*</span></label>
            </template>
            <v-select
              v-model="assignWorkflowData.collection_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="collectionOptions"
              :reduce="(val) => val.id"
              :state="errors.length > 0 ? false : null"
              placeholder="--Chọn--"
              label="name"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
          <div class="mt-3 mb-1 text-center">
            <b-button
              variant="primary"
              type="submit"
            >
              {{ $t('Save') }}
            </b-button>
          </div>
        </validation-provider>

      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BCard, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, reactive,
} from '@vue/composition-api'
import store from '@/store'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required,
} from '@validations';
import useGroups from './useGroups';

export default {
  components: {
    BCard,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    // Ripple,
  },
  props: {
    groupData: null,
  },
  data() {
    return {
      required,
    }
  },
  computed: {

  },
  setup(props, context) {
    const workflowOptions = ref([]);
    const collectionOptions = ref([]);
    const roleOptions = ref([]);
    const assignWorkflowData = reactive({
      workflow_id: 0,
      collection_id: 0,
    });
    const assignRoleData = reactive({
      role_id: 0,
      collection_id: 0,
    });
    const formGroupAssign = ref(null);

    const {
      loading,
    } = useGroups();

    const fetchWorkflow = () => {
      loading.value = true;
      store.dispatch('workflow/fetchAll', { type: 'all' })
        .then(response => {
          if (response.status === 200) {
            workflowOptions.value = response.data.data
            loading.value = false
          } else {
            loading.value = false
          }
        })
    }
    const fetchCollection = () => {
      loading.value = true;
      store.dispatch('collection/fetchAll', { type: 'all' })
        .then(response => {
          if (response.status === 200) {
            collectionOptions.value = response.data.data
            loading.value = false
          } else {
            loading.value = false
          }
        })
    }
    const fetchRole = () => {
      loading.value = true;
      store.dispatch('roles/fetchRoles', { isPaginate: 0 })
        .then(response => {
          if (response.status === 200) {
            roleOptions.value = response.data.data
            loading.value = false
          } else {
            loading.value = false
          }
        })
    }
    const saveGroupAssign = () => {
      loading.value = false
      formGroupAssign.validate().then(success => {
        if (success) {
          // console.log('valida succs');
        }
      })
    }
    if (props.groupData !== undefined && props.groupData.id) {
      fetchWorkflow();
      fetchCollection();
      fetchRole();
    }

    return {
      loading,
      roleOptions,
      collectionOptions,
      workflowOptions,
      assignRoleData,
      assignWorkflowData,
      saveGroupAssign,
      formGroupAssign,
    }
  },
}
</script>

<style></style>
